import { DelegateMapEntry } from 'containers/Base/ActionDelegate';
import { FETCH_APPS } from 'containers/Product/Applications/store/appSelector/actions/FetchApps';
import { FETCH_MODULES } from 'containers/Product/Modules/store/moduleSelector/actions/FetchModules';
import { App } from 'data/terra/App';
import { Module } from 'data/terra/Module';
import { Product } from 'data/terra/Product';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import Terra from 'services/apis/terra/Terra';
import { RootState } from 'store/reducer';
import { ProductSelectorState } from '../reducer';

export const selectProduct = (
  productId: string
): ThunkAction<void, RootState, unknown, Action<string>> => async (
  dispatch,
  getState
) => {
  let apps: App[] = [];
  let modules: Module[] = [];

  const appsResult = await Terra.app.fetchApps(productId);
  if (appsResult.isSuccess()) {
    apps = appsResult.get()!.data;
    dispatch({
      type: FETCH_APPS,
      apps,
    });
  }

  const modulesResult = await Terra.module.fetchModules(productId);
  if (modulesResult.isSuccess()) {
    modules = modulesResult.get()!.data;
    dispatch({
      type: FETCH_MODULES,
      modules,
    });
  }

  const selectedProduct = getState().productSelector.products.find(
    p => p.id === productId
  );

  dispatch({
    type: SELECT_PRODUCT,
    selectedProduct,
  });
};

export const SELECT_PRODUCT = 'SELECT_PRODUCT';

export interface SelectProductAction {
  type: typeof SELECT_PRODUCT;
  selectedProduct: Product;
}

export const selectProductDelegate: DelegateMapEntry<
  SelectProductAction,
  ProductSelectorState
> = {
  [SELECT_PRODUCT]: (
    state: ProductSelectorState,
    action: SelectProductAction
  ): ProductSelectorState => {
    return {
      ...state,
      selectedProduct: action.selectedProduct,
    };
  },
};
